import EditablePropsType from '../../../types/composer';

export type ResourceProps = { citation: string };
export type ResourceLinkProps = { url: string; title: string };

export const resourceSchema = {
  type: EditablePropsType.Object,
  name: 'resource',
  properties: {
    citation: {
      type: EditablePropsType.Text,
      name: 'citation',
      label: 'Citation',
    },
  },
};

export const resourceLinkSchema = {
  type: EditablePropsType.Object,
  label: 'Link',
  name: 'link',
  properties: {
    title: {
      type: EditablePropsType.Text,
      name: 'title',
      label: 'Link Text',
    },
    url: {
      type: EditablePropsType.Text,
      name: 'url',
      label: 'URL',
    },
  },
};

export const resourcesSchema = {
  label: 'Resources',
  name: 'resources',
  type: EditablePropsType.Array,
  items: resourceSchema,
};

export const resourceLinksSchema = {
  label: 'Links',
  name: 'links',
  type: EditablePropsType.Array,
  items: resourceLinkSchema,
};

export const resourcesHeaderTextSchema = {
  type: EditablePropsType.Text,
  label: 'Resources Header Text',
  name: 'resourcesHeaderText',
  defaultValue: 'Resources for research and reference',
};

export const linksHeaderTextSchema = {
  type: EditablePropsType.Text,
  label: 'Links Header Text',
  name: 'linksHeaderText',
  defaultValue: 'Related links',
};
